import React, {useEffect, useState, useContext} from 'react';
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify"
import { AuthContext } from "../context/authContext";
import {useEstadoApp} from "../context/EstadoAppContext";

//import ButtonNavLink from './ui/ButtonNavLink';
import FormularioNuevaONG from './FormularioNuevaONG'; // Importar el formulario
//import FormularioNuevoReferente from './FormularioNuevoReferente'; // Importar el formulario de referente
import { Modal } from './ui/Modal'; // Importar el componente Modal reutilizable

import ImageNav from '../marca_botonera-01.png';
import ImageNavRED from '../logo_RED-01.png';

const Navbar = () => {
	const auth = useContext(AuthContext) //**agregado */
	const { user, logout, role, isEspecial, userMunicipio } = useContext(AuthContext);
    const {estadoAppX} = useEstadoApp();

    const [isModalOpen, setIsModalOpen] = useState(false); // Estado para el modal
    const [modalType, setModalType] = useState(null); // Estado para el tipo de modal
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // Estado para menú móvil
    //const [refreshKey, setRefreshKey] = useState(0); // Estado para refrescar datos    

	useEffect(()=>{
        if(user){
            toast(`Bienvenido: ${user}`);
        }
    },[user])

	// Clases base para los enlaces
	const linkClasses = ({ isActive }) =>
		`px-4 py-2 rounded-md transition-colors duration-200 text-sm font-medium hover:text-white/80 hover:bg-white/20 ${isActive
			? 'text-white !bg-[#476c97]'
			: 'text-white dark:text-[#476c97]'
		}`;

	// Clases para enlaces en menú móvil
	const mobileLinkClasses = ({ isActive }) =>
		`block px-4 py-3 rounded-md transition-colors duration-200 text-sm font-medium hover:text-white/80 hover:bg-white/20 ${isActive
			? 'text-white !bg-[#476c97]'
			: 'text-white'
		}`;

	const closeModal = () => {
		setIsModalOpen(false);
		setModalType(null);
	};

	const toggleMobileMenu = () => {
		setMobileMenuOpen(!mobileMenuOpen);
	};

	return (
		<>
		<nav className="relative w-full grid grid-cols-[1fr_auto_1fr] items-center px-4 transition-colors duration-300">
			{/* COLUMNA IZQUIERDA: Botón hamburguesa (móvil) + Nav links (desktop) */}
			<div className="flex items-center justify-start">
				{/* Botón hamburguesa - Móvil only */}
				<div className="md:hidden flex items-center">
					<button
						onClick={toggleMobileMenu}
						className="p-2 rounded-md text-white hover:bg-white/20 transition-colors"
						aria-label="Abrir menú"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-6 w-6"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							{mobileMenuOpen ? (
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M6 18L18 6M6 6l12 12"
								/>
							) : (
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M4 6h16M4 12h16M4 18h16"
								/>
							)}
						</svg>
					</button>
				</div>

				{/* Enlaces de navegación - Desktop only */}
				<div className="hidden md:flex items-center space-x-2">
					<NavLink to="/inicio" className={linkClasses}>
						Inicio
					</NavLink>
					<NavLink to="/mapa-privado" className={linkClasses}>
						Mapa
					</NavLink>
					<NavLink to="/informes" className={linkClasses}>
						Informes
					</NavLink>
					{(role === 'admin' || role === 'editor_provincial' || role === 'editor_municipio') && (
						<NavLink to="/tablero" className={linkClasses}>
							Tablero
						</NavLink>
					)}
					{(role === 'admin' || role === 'editor_provincial' || role === 'editor_municipio') && (
						<NavLink to="/estadisticas" className={linkClasses}>
							Estadísticas
						</NavLink>
					)}

					{(role === 'admin' || user === 'Javier') && (
						<>
							<NavLink to="/admin/solicitudes-usuarios" className={linkClasses}>
								Validar s. municipales
							</NavLink>
							<NavLink to="/admin/crear-usuario-provincial" className={linkClasses}>
								Crear usuario
							</NavLink>
							<NavLink to="/admin/event-history" className={linkClasses}>
								Historial de Eventos
							</NavLink>
						</>
					)}
					{(role === 'admin' || (role === 'editor_provincial' && isEspecial)) && (
						<NavLink to="/admin/usuarios" className={linkClasses}>
							Usuarios
						</NavLink>
					)}
					{(role === 'admin' || (role === 'editor_provincial' && isEspecial) || (role === 'editor_municipio' && !!userMunicipio)) && (
						<NavLink to="/admin/osm" className={linkClasses}>
							Validación OSM
						</NavLink>
					)}
					{role === 'editor_provincial' && !isEspecial && (
						<NavLink to="/admin/solicitudes-usuarios" className={linkClasses}>
							Validar s. municipales
						</NavLink>
					)}
					{role === 'editor_provincial' && isEspecial && (
						<>
							<NavLink to="/admin/solicitudes-usuarios" className={linkClasses}>
								Validar s. municipales
							</NavLink>
							<NavLink to="/admin/solicitudes-entidades" className={linkClasses}>
								Validar s. entidades
							</NavLink>
						</>
					)}
					{role === 'editor_municipio' && (
						<NavLink to="/admin/solicitudes-entidades" className={linkClasses}>
							Validar s. entidades
						</NavLink>
					)}
				</div>
			</div>

			{/* COLUMNA CENTRO: Logo */}
			<div className="flex items-center justify-end md:justify-center h-full">
				<div className="h-full flex items-center gap-4">
					{/* Logo 2 - Reemplazar cuando se tenga la segunda imagen */}
					<img
						src={ImageNavRED}
						alt="Logo RED"
						className="
						/* Móvil: Altura fija pequeña */
						h-20
						/* Desktop: Ancho controlado, altura automática */
						md:h-auto
						md:w-full
						md:max-w-[200px]
						/* Mantenemos proporción */
						object-contain
						"
					/>
					{/* Logo 1 */}
					<img
						src={ImageNav}
						alt="Logo provincia de Bs As"
						className="
						/* Móvil: Altura fija pequeña */
						h-20
						/* Desktop: Ancho controlado, altura automática */
						md:h-auto
						md:w-full
						md:max-w-[200px]
						/* Mantenemos proporción */
						object-contain
						"
					/>					
				</div>
			</div>

			{/* COLUMNA DERECHA: Usuario (desktop) - vacío en móvil */}
			<div className="hidden md:flex items-center justify-end w-full">
				<div className='flex items-center justify-end gap-3 w-full'>
					{user && (
						<span className="text-sm text-white font-medium">
							Bienvenido, {auth?.user && user}
						</span>
					)}
					{user ? (
						<button
							onClick={logout}
							className="px-4 py-2 rounded-md text-sm font-medium text-white hover:bg-white/20 transition-colors"
						>
							Cerrar sesión
						</button>
					) : (
						<NavLink to="/login" className={linkClasses}>
							Ingreso usuario
						</NavLink>
					)}
				</div>
			</div>

			{/* Menú móvil desplegable */}
			{mobileMenuOpen && (
				<div className="md:hidden absolute top-full left-0 right-0 z-50 bg-gradient-to-r from-[#e81f76] via-[#417099] to-[#00AEC3] border-t border-white/20 shadow-lg">
					<div className="px-4 py-2 space-y-1">
						<NavLink
							to="/inicio"
							className={mobileLinkClasses}
							onClick={() => setMobileMenuOpen(false)}
						>
							Inicio
						</NavLink>
						<NavLink
							to="/mapa-privado"
							className={mobileLinkClasses}
							onClick={() => setMobileMenuOpen(false)}
						>
							Mapa
						</NavLink>
						<NavLink
							to="/informes"
							className={mobileLinkClasses}
							onClick={() => setMobileMenuOpen(false)}
						>
							Informes
						</NavLink>
						{(role === 'admin' || role === 'editor_provincial' || role === 'editor_municipio') && (
							<NavLink
								to="/tablero"
								className={mobileLinkClasses}
								onClick={() => setMobileMenuOpen(false)}
							>
								Tablero
							</NavLink>
						)}
						{(role === 'admin' || role === 'editor_provincial' || role === 'editor_municipio') && (
							<NavLink
								to="/estadisticas"
								className={mobileLinkClasses}
								onClick={() => setMobileMenuOpen(false)}
							>
								Estadísticas
							</NavLink>
						)}
						{(role === 'admin' || user === 'Javier') && (
							<>
								<NavLink
									to="/admin/solicitudes-usuarios"
									className={mobileLinkClasses}
									onClick={() => setMobileMenuOpen(false)}
								>
									Solicitudes municipales
								</NavLink>
								<NavLink
									to="/admin/crear-usuario-provincial"
									className={mobileLinkClasses}
									onClick={() => setMobileMenuOpen(false)}
								>
									Crear usuario
								</NavLink>
								<NavLink
									to="/admin/event-history"
									className={mobileLinkClasses}
									onClick={() => setMobileMenuOpen(false)}
								>
									Historial de Eventos
								</NavLink>
							</>
						)}
						{(role === 'admin' || (role === 'editor_provincial' && isEspecial)) && (
							<NavLink
								to="/admin/usuarios"
								className={mobileLinkClasses}
								onClick={() => setMobileMenuOpen(false)}
							>
								Usuarios
							</NavLink>
						)}
						{(role === 'admin' || (role === 'editor_provincial' && isEspecial) || (role === 'editor_municipio' && !!userMunicipio)) && (
							<NavLink
								to="/admin/osm"
								className={mobileLinkClasses}
								onClick={() => setMobileMenuOpen(false)}
							>
								Validación OSM
							</NavLink>
						)}
						{role === 'editor_provincial' && !isEspecial && (
							<NavLink
								to="/admin/solicitudes-usuarios"
								className={mobileLinkClasses}
								onClick={() => setMobileMenuOpen(false)}
							>
								Validar solicitudes municipales
							</NavLink>
						)}
						{role === 'editor_provincial' && isEspecial && (
							<>
								<NavLink
									to="/admin/solicitudes-usuarios"
									className={mobileLinkClasses}
									onClick={() => setMobileMenuOpen(false)}
								>
									Solicitudes municipales
								</NavLink>
								<NavLink
									to="/admin/solicitudes-entidades"
									className={mobileLinkClasses}
									onClick={() => setMobileMenuOpen(false)}
								>
									Validar solicitudes entidades
								</NavLink>
							</>
						)}
						{role === 'editor_municipio' && (
							<NavLink
								to="/admin/solicitudes-entidades"
								className={mobileLinkClasses}
								onClick={() => setMobileMenuOpen(false)}
							>
								Validar solicitudes entidades
							</NavLink>
						)}
						<div className="border-t border-white/20 pt-2 mt-2">
						{user ? (
							<button
								onClick={() => { logout(); setMobileMenuOpen(false); }}
								className="block w-full text-left px-4 py-3 rounded-md text-sm font-medium text-white hover:text-white/80 hover:bg-white/20 transition-colors"
							>
								Cerrar sesión
							</button>
						) : (
							<NavLink
								to="/login"
								className={mobileLinkClasses}
								onClick={() => setMobileMenuOpen(false)}
							>
								Ingreso usuario
							</NavLink>
						)}
					</div>
				</div>
			</div>
		)}
	</nav>

        {/* Usar el componente Modal reutilizable */}
        <Modal isOpen={isModalOpen} onClose={closeModal} maxWidth="max-w-4xl">
            <div className="w-full">
                <div className="space-y-4 p-4 rounded-lg bg-white dark:bg-gray-900">
                    <h3 className="text-lg font-semibold mb-3 dark:text-gray-200">Nueva ONG</h3>
                    <FormularioNuevaONG />
                </div>                
            </div>
        </Modal>

		</>	
		
	);
};

export default Navbar;
